import { GETQuery } from '../langs';

export function isPdfMode(): boolean {
    const searchParams = new URLSearchParams(window.location.search);
    const [key, value] = GETQuery.split('=');
    return searchParams.get(key) === value;
}
